import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/removal_installation_list/')({
    component: RemovalInstallationList,
});

function RemovalInstallationList() {
    return <Navigate to="/" />;
}
